import React from 'react';
import LoadingSpinner from '../shared/LoadingSpinner';

/**
 * OrganizationRow - Individual row component for organizations table
 * 
 * @param {Object} props - Component props
 * @param {Object} props.organization - Organization data object
 * @param {string} props.organization.id - Organization ID
 * @param {string} props.organization.name - Organization name
 * @param {string} props.organization.rootAdminUserId - ID of root admin user
 * @param {number} props.organization.membersCount - Number of members
 * @param {number} props.index - Row index for border styling
 * @param {number} props.totalRows - Total number of rows for border styling
 * @param {Array} props.users - All users for finding root admin
 * @param {string|null} props.processingAction - ID of organization currently being processed
 * @param {Function} props.onAssignRootAdmin - Called when assign root admin button is clicked
 * @param {Function} props.onDeleteOrganization - Called when delete button is clicked
 * @returns {React.ReactElement} Organization row component
 */
const OrganizationRow = ({
  organization,
  index,
  totalRows,
  users,
  processingAction,
  onAssignRootAdmin,
  onDeleteOrganization
}) => {
  const isActionPending = processingAction === organization.id;
  const owner = users.find(u => u.id === organization.rootAdminUserId);

  return (
    <tr 
      key={organization.id} 
      style={{ 
        borderBottom: index < totalRows - 1 ? '1px solid var(--border)' : 'none', 
        transition: 'var(--transition)' 
      }} 
      className="table-row-hover"
    >
      <td style={{ padding: '0.5rem 0.75rem', fontSize: '0.9rem', color: 'var(--text-primary)', fontWeight: 600 }}>
        {organization.name}
      </td>
      <td style={{ padding: '0.5rem 0.75rem', fontSize: '0.9rem', color: 'var(--text-secondary)', fontFamily: 'monospace' }}>
        {organization.id}
      </td>
      <td style={{ padding: '0.5rem 0.75rem', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' }}>
          {owner ? (
            <div>
              <div style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{owner.fullName || owner.email}</div>
              <div style={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>{owner.email}</div>
            </div>
          ) : (
            <span style={{ fontStyle: 'italic', color: 'var(--text-secondary)', fontSize: '0.85rem' }}>No Owner Assigned</span>
          )}
          <button
            onClick={() => onAssignRootAdmin(organization)}
            style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--text-secondary)', padding: '4px', display: 'flex', alignItems: 'center' }}
            title="Assign Root Administrator"
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </button>
        </div>
      </td>
      <td style={{ padding: '0.5rem 0.75rem', fontSize: '0.9rem', color: 'var(--text-primary)', fontWeight: 600, textAlign: 'center' }}>
        {organization.membersCount}
      </td>
      <td style={{ padding: '0.5rem 0.75rem', textAlign: 'right' }}>
        <button 
          disabled={isActionPending}
          onClick={() => onDeleteOrganization(organization.id, organization.name)}
          className="family-menu-trigger delete" 
          style={{ 
            padding: '4px 8px', 
            color: 'var(--error)', 
            background: 'transparent', 
            border: 'none', 
            cursor: 'pointer', 
            borderRadius: '4px', 
            transition: 'var(--transition)' 
          }}
          title="Delete Organization Organization"
        >
          <i className="fa-solid fa-trash-can"></i>
        </button>
      </td>
    </tr>
  );
};

export default OrganizationRow;